import kirollusImage from "./images/kirollus.webp";
import theCauseImage from "./images/thecause.webp";
import sightedImage from "./images/sighted.webp";
import subFocusImage from "./images/subfocus.webp";
import nightlifeImage from "./images/nightlife.webp";

const v = (name: string) => `/videos/${name}`;
const vs = (n: number, prefix: string = "", ext: string = "webm") => Array.from({ length: n }, (_, i) => v(`${prefix}${i + 1}.${ext}`));

export type VideoCategory = {
  id: string;
  image: string;
  title: string;
  videos: readonly string[];
};

/** Nightlife / live music — two segments in one story for the progress UI demo */
export const categories: readonly VideoCategory[] = [
  {
    id: "kirollus",
    title: "Kirollus",
    image: kirollusImage,
    videos: [v("kirollus.webm")],
  },
  {
    id: "thecause",
    title: "The Cause",
    image: theCauseImage,
    videos: [v("thecause.webm")],
  },
  {
    id: "sighted",
    title: "Sighted Magazine",
    image: sightedImage,
    videos: [v("sighted.webm")],
  },
  {
    id: "subfocus",
    title: "Sub Focus (Depot)",
    image: subFocusImage,
    videos: vs(7, "subfocus", "webm"),
  },
  {
    id: "nightlife",
    title: "Nightlife",
    image: nightlifeImage,
    videos: vs(6, "nightlife", "webm"),
  }
] as const;
